import produce from 'immer';

import { FETCH_PROFILE_SUCCEEDED, LOGOUT } from '../../constants/actionTypes';

const initState = null;

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_PROFILE_SUCCEEDED: {
      return action.payload;
    }

    case LOGOUT: {
      return initState;
    }
  }
}, initState);
